import request from '@/utils/request'

export function index(params) {
  return request({
      url: '/settings/anecdotes',
      method: 'get',
      params: params
  })
}

export function show(id) {
  return request({
      url: `/settings/anecdotes/${id}`,
      method: 'get'
  })
}

export function store(data) {
  return request({
      url: '/settings/anecdotes',
      method: 'post',
      data
  })
}

export function update(data) {
  return request({
      url: `/settings/anecdotes/${data.id}`,
      method: 'put',
      data
  })
}

export function destroy(id) {
  return request({
      url: `/settings/anecdotes/${id}`,
      method: 'delete',
  })
}
